import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bdg-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent {
  @Input() accent: 'red' | 'teal' | 'blue' | 'warning' | 'indigo' | 'orange' | 'gray'

  @Input() icon: string
}
